import Vue from "vue";
import Router from "vue-router";
import Home from "@/newComponents/Home";
import Schedule from "@/newComponents/Schedule";
import Archive from "@/newComponents/Archive";
import About from "@/newComponents/About";
import Privacy from "@/newComponents/Privacy";
import Login from "@/newComponents/Login";
import Logout from "@/newComponents/Logout";
import Subscribe from "@/newComponents/Subscribe";
import Detail from "@/newComponents/Detail";
import Imprint from "@/newComponents/Imprint";
import ResetPW from "@/newComponents/ResetPW";
import ConfirmEmail from "@/newComponents/ConfirmEmail";
import NewPW from "@/newComponents/NewPW";
import StreamDetail from "@/newComponents/StreamDetail";
import ShopDetail from "@/newComponents/ShopDetail";
import ShopList from "@/newComponents/ShopList";
import Cart from "@/newComponents/Cart";
import Proposal from "@/newComponents/Proposal";
import SeriesList from "@/newComponents/SeriesList";
import SeriesDetail from "@/newComponents/SeriesDetail";

Vue.use(Router);

export default new Router({
    // scrollBehavior(to, from, savedPosition) {
    //     let pos;
    //     if ("scrollPos" in to.meta) {
    //         pos = to.meta.scrollPos;
    //     }
    //     if (pos) {
    //         return { x: 0, y: pos };
    //     } else {
    //         return { x: 0, y: 0 };
    //     }
    // },
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
        },
        {
            path: "/schedule",
            name: "schedule",
            redirect: "upcoming",
        },
        {
            path: "/upcoming",
            name: "upcoming",
            component: Schedule,
        },
        {
            path: "/live",
            name: "live",
            redirect: "upcoming",
        },
        {
            path: "/archive",
            name: "archive",
            component: Archive,
            meta: {
                scrollPos: {
                    x: 0,
                    y: 0,
                },
            },
        },
        {
            path: "/imprint",
            name: "imprint",
            component: Imprint,
        },
        {
            path: "/about",
            name: "about",
            component: About,
        },
        {
            path: "/privacy-policy",
            name: "privacy",
            component: Privacy,
        },
        {
            path: "/login",
            name: "login",
            component: Login,
        },
        {
            path: "/reset-password",
            name: "resetPW",
            component: ResetPW,
        },
        {
            path: "/create-password/:email",
            name: "newPW",
            component: NewPW,
        },
        {
            path: "/confirm-email/:email",
            name: "confirmEmail",
            component: ConfirmEmail,
        },
        {
            path: "/logout",
            name: "logout",
            component: Logout,
        },
        {
            path: "/support",
            name: "subscribe",
            component: Subscribe,
        },
        {
            path: "/subscribe",
            redirect: { name: "subscribe" },
        },
        {
            path: "/support/:hash",
            name: "subscribe_hash",
            component: Subscribe,
        },
        {
            path: "/subscribe/:hash",
            redirect: { name: "subscribe_hash" },
        },
        {
            path: "/show/:id",
            name: "detail",
            component: Detail,
        },
        {
            path: "/stream/:slug",
            name: "streamDetail",
            component: StreamDetail,
        },
        {
            path: "/archive/:id",
            redirect: "/show/:id",
            name: "detailRedirect",
            component: Detail,
        },
        {
            path: "/shop/:id",
            name: "shopDetail",
            component: ShopDetail,
        },
        {
            path: "/shop",
            name: "shopList",
            component: ShopList,
        },
        {
            path: "/series/:slug",
            name: "seriesDetail",
            component: SeriesDetail,
        },
        {
            path: "/series",
            name: "seriesList",
            component: SeriesList,
        },

        {
            path: "/cart",
            name: "cart",
            component: Cart,
        },
        {
            path: "/submit",
            name: "proposal",
            component: Proposal,
        },
    ],
});
